import Vue from 'vue'
import App from './App'
import jquery from 'jquery'
import "bootstrap/dist/css/bootstrap.css"

import {
    library
} from '@fortawesome/fontawesome-svg-core'
import {
    faCoffee,
    faChild,
    faCircle,
    faArchive,
    faEnvelope,
    faCheck,
    faAddressCard,
    faBriefcase,
    faGraduationCap,
    faAward,
    faDiceD6,
    faCompass
} from '@fortawesome/free-solid-svg-icons'
//import { faAxeBattle } from '@fortawesome/free-regular-svg-icons'
import {
    faTwitter,
    faGithub,
    faLinkedin,
    faVuejs
} from '@fortawesome/free-brands-svg-icons'
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

library.add(
    faCoffee, faBriefcase, faGraduationCap, faAward, faDiceD6, faCheck, faAddressCard,
    faChild, faCircle, faArchive, faEnvelope, faTwitter,
    faGithub, faLinkedin, faCompass, faVuejs
)

require('bootstrap')
require('jquery.easing')
require('devicons/css/devicons.css')


Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.jquery = jquery
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js